<template>
  <v-btn-toggle
    v-model="tableMode"
    class="mode-btns"
    group>
    <v-btn
      class="pa-0"
      :class="{'active': !tableMode}"
      :disabled="disabled"
      icon
      small
      :value="false">
      <sIcon type="calendar"/>
    </v-btn>
    <v-btn
      class="pa-0"
      :class="{'active': tableMode}"
      :disabled="disabled"
      icon
      small
      :value="true">
      <sIcon type="table"/>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'modeButtons',
  props: {
    mode: [Boolean, String, Number],
    disabled: Boolean
  },
  computed: {
    tableMode: {
      get() {
        return this.mode
      },
      set(value) {
        this.$emit('update:mode', value === undefined ? !this.mode : value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mode-btns {
  z-index: 20;
  //position: absolute;
  //top: 89px !important;
  //right: 25px;
  .v-btn {
    width: 14px;
    opacity: 0.2;

    &.active  {
      opacity: 1
    }
    &::before {
      opacity: 0 !important;
    }
  }

}
</style>>
